import React, { useEffect, useState } from 'react';
import { Message } from 'semantic-ui-react';
import { getFreshIdToken } from '../../utils/authUtil';

export default function DisclosureNotice({ book }) {
  const [noticeAt, setNoticeAt] = useState(book.aiDisclosureNoticeAt);
  const pending =
    book.privacy === 'listed' &&
    book.content?.some(v => v.parts?.length && !v.aiDisclosure?.type);
  useEffect(() => {
    if (!pending || book.role !== 'author' || noticeAt) return;
    let active = true;
    (async () => {
      try {
        const token = await getFreshIdToken();
        const response = await fetch(
          `${process.env.REACT_APP_API_HOST}${process.env.REACT_APP_API_PATH}/books/${book._id}/ai-disclosure-notice`,
          { method: 'POST', headers: { 'br-token': token } }
        );
        if (response.ok) {
          const data = await response.json();
          if (active) setNoticeAt(data.noticeAt);
        }
      } catch (_) {
        /* Keep the notice visible and retry on the next visit. */
      }
    })();
    return () => {
      active = false;
    };
  }, [pending, book._id, book.role, noticeAt]);
  if (!pending) return null;
  const deadline = noticeAt
    ? new Date(
        new Date(noticeAt).getTime() + 30 * 86400000
      ).toLocaleDateString()
    : null;
  return (
    <Message warning>
      <Message.Header>Please declare AI use</Message.Header>
      <p>
        Existing Discovery listings need a declaration within 30 days of this
        notice{deadline ? ` (by ${deadline})` : ''}. After that, undeclared
        versions are hidden from Discovery until declared. Existing reader
        access is retained.
      </p>
      <p>
        Use the AI disclosure section below. Older work is not assumed to be
        human-written.
      </p>
    </Message>
  );
}
